import React from 'react';
import ServicePage from '../components/services/ServicePage';
import gazebos from '../data/services/gazebos';

const Gazebos: React.FC = () => <ServicePage data={gazebos} />;

export default Gazebos;
